var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":"top","content":_vm.params.value}},[_c('div',[_c('a',{attrs:{"target":"_blank","href":("" + (_vm.params.value))}},[_vm._v(_vm._s(_vm.params.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }